import { TWEEN_ONCOMPLETE } from "Data/Constants";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, Sine, TimelineLite, TimelineMax, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import {ch5_p06} from "../../../layouts/ch5_p06/ch5_p06";

export class Chapter5Page6 extends AbstractStoryState {

    readonly bg = this.addChild(new SceneSprite());
    readonly hollyHorse = this.addChild(new SceneSprite());

    readonly butterflyContainer = this.addChild(new PIXI.Container());
    readonly butterfly = list(()=>this.butterflyContainer.addChild(new SceneSprite()));

	readonly frameLeft = this.addChild(SceneSprite.withPrefix("ch5_p06/"));
	readonly frameRight = this.addChild(SceneSprite.withPrefix("ch5_p06/"));
	readonly linesLeft = this.addChild(SceneSprite.withPrefix("ch5_p06/"));
	readonly linesRight = this.addChild(SceneSprite.withPrefix("ch5_p06/"));

    protected elapsedTime: number = 0;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layouts from Animate CC
        ch5_p06.call(this);
        this.frameLeft.visible = false;
		this.frameRight.visible = false;

        this.butterfly.forEach(s=>s.visible = false);
        this.butterfly[0].visible = true;

		// super.init calls onResize
        super.init(pSize, pData);
	}

	public update(pDeltaTime: number) {
        super.update(pDeltaTime);

        this.elapsedTime += pDeltaTime;

        // bit of a hacky way of flipping through an array of sprites but it works...
        const fps = 6;
        if (this.elapsedTime > 1/fps) {
            this.butterfly.push(this.butterfly.shift()!);
            this.butterfly.forEach(s=>s.visible = false);
            this.butterfly[0].visible = true;
            this.elapsedTime = 0;
        }
	}

	public animateIn(pOnComplete: ()=>void) {
        super.animateIn(pOnComplete);
        this.butterflyContainer.pivot.copyFrom(this.butterfly[0].position);
        this.butterflyContainer.position.copyFrom(this.butterfly[0].position);
        // butterfly enter tween
        TweenLite.from(this.butterflyContainer, 3, {pixi: {
            scale: 0.2,
            x: this.butterflyContainer.x - 200,
            y: this.butterflyContainer.y + (this._size.y / 2) + 100,
        }, ease: Expo.easeOut})
        .eventCallback(TWEEN_ONCOMPLETE, ()=>{
            // butterfly hover loop
            TweenMax.to(this.butterflyContainer, 1, {pixi: {y: this.butterflyContainer.y + 20}, ease: Sine.easeInOut}).yoyo(true).repeat(-1);
        })
        .delay(3);

        // fade out old background music
		const prevLoop = Application.instance.audio.getAudioTrack("HH_Ch5_LoopA_P1-5", HLF.AudioCategory.BGM);
		prevLoop?.fadeTo(0, 1000);
		prevLoop?.once(HLF.HowlerUtils.Events.FADE, ()=>{
			prevLoop.unloadSource();
		});

        Application.instance.audio.play("HH_Ch5_Holly_On_Horseback_LoopB_P6-9", 1, true, HLF.AudioCategory.BGM);
    }

    public animateOut(pOnComplete: ()=>void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();
        this.butterflyContainer.interactive = true;
        this.butterflyContainer.buttonMode = true;
        this.butterflyContainer.accessible = true;
        this.butterflyContainer.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
            this.gotoNextState({transition: "left"});
        });
    }
}